import { z } from "zod";

import { cityOrRegionField, isNotInFuture, isRealCalendarDate, isStartOnOrBeforeEnd, requiredString } from "./fields";

export const workExperienceSchema = z
	.object({
		jobTitle: requiredString("Job title is required"),
		employer: requiredString("Employer is required"),
		address: cityOrRegionField("Please enter a work city or region"),
		country: requiredString("Country is required"),
		startDate: requiredString("Start date is required")
			.refine(isRealCalendarDate, "Enter a valid start date")
			.refine(isNotInFuture, "Start date can't be in the future"),
		endDate: z.string(),
		currentEmployer: z.union([z.boolean(), z.literal("")]),
	})
	.superRefine(({ currentEmployer, endDate, startDate }, ctx) => {
		if (currentEmployer) return;

		if (!endDate.trim()) {
			ctx.addIssue({ code: "custom", path: ["endDate"], message: "End date is required" });
			return;
		}
		if (!isRealCalendarDate(endDate)) {
			ctx.addIssue({ code: "custom", path: ["endDate"], message: "Enter a valid end date" });
			return;
		}
		if (!isNotInFuture(endDate)) {
			ctx.addIssue({ code: "custom", path: ["endDate"], message: "End date can't be in the future" });
		}
		if (isRealCalendarDate(startDate) && !isStartOnOrBeforeEnd(startDate, endDate)) {
			ctx.addIssue({
				code: "custom",
				path: ["endDate"],
				message: "End date can't be before the start date",
			});
		}
	});

export type WorkExperienceFormValues = z.infer<typeof workExperienceSchema>;
